type NotificationCallback = (message: string) => void;

let successCallback: NotificationCallback | null = null;
let errorCallback: NotificationCallback | null = null;

export class NotificationService {
    static setSuccessCallback(callback: NotificationCallback): void {
        successCallback = callback;
    }

    static setErrorCallback(callback: NotificationCallback): void {
        errorCallback = callback;
    }

    static showSuccess(message: string): void {
        if (successCallback) {
            successCallback(message);
        } else {
            console.log('Success:', message);
        }
    }

    static showError(message: string): void {
        if (errorCallback) {
            errorCallback(message);
        } else {
            console.error('Error:', message);
        }
    }

    static showPrintNotification(): void {
        this.showSuccess('Comprovante gerado com sucesso!');
    }

    static showEmailNotification(): void {
        this.showSuccess('Email enviado com sucesso!');
    }
}

